import type { WP_REST_API_Post } from 'wp-types';
import { createCachedAPI } from '../utils/api';

export const getPost = createCachedAPI<WP_REST_API_Post>(
  `${window.location.origin}/wp-json/wp/v2`,
  {
    query: '_fields=title.rendered,content.rendered',
  },
);
